module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_pp2_9006.1d3e5c12.png";